export default "__VITE_ASSET___YcYkjRt__"